import { IFilterElement } from "@saleor/components/Filter";
import { getSingleValueQueryParam } from "@saleor/utils/filters";

import {
  MallShippingLogsUrlFilters,
  MallShippingLogsUrlFiltersEnum
} from "../urls";
import { MallShippingLogsFilterKeys } from "./filters";

export function getFilterQueryParam(
  filter: IFilterElement<MallShippingLogsFilterKeys>
): MallShippingLogsUrlFilters | null {
  const { name } = filter;

  if (name === MallShippingLogsFilterKeys.event) {
    return getSingleValueQueryParam(
      filter,
      MallShippingLogsUrlFiltersEnum.event
    );
  }

  return null;
}
